import React from 'react'
import { useHistory } from 'react-router'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import DrawerAddCampaignStep1 from '~/pages/cp/campaigns/add/drawerAddCampaignStep1'
import { alterFullpage, alterSiteDrawer } from '~/data/actions/siteActions'
import { useDispatch } from 'react-redux'
import CreateAutomationModal from '~/pages/cp/includes/automations/createAutomationModal'

export default function ActionExplainer({ app, accApp, action }) {
  const history = useHistory()
  const dispatch = useDispatch()

  const createAutomation = () => {
    dispatch(alterFullpage(<CreateAutomationModal onClose={() => dispatch(alterFullpage(null))} />))
  }

  const createCampaign = async () => {
    // ask for a template then create a campaign with that group and on the integration panel already
    let groups
    if (accApp.appSettings.groupId) {
      groups = [{ id: accApp.appSettings.groupId, include: true }]
    }
    const drawer = <DrawerAddCampaignStep1 history={history} Groups={groups} />
    dispatch(alterSiteDrawer(true, false, 'right', drawer, true, 500, 'drawer_nopad'))
  }

  return (
    <div>
      <h4 className='mar-b25'>{action.name}</h4>
      <div className='mar-b25'>{action.description}</div>
      <Button text='Create Campaign' onClick={createCampaign} className='full-width primary button-md mar-b20' />
      <Button
        text='Create Automation'
        onClick={createAutomation}
        className='full-width primary button-md mar-b20'
      />
    </div>
  )
}
